import React, { useState } from 'react';
import Icon from 'components/Icon';
import {
  NavItemHeader,
  NavSubItem,
  NavSubMenuText,
} from '../StyledAdminMobileLayout';

const SubMenu = ({ item, hideMenu }) => {
  const [active, setActive] = useState(false);

  return (
    <>
      <NavItemHeader key={item.id} onClick={() => setActive(!active)}>
        <div
          style={{
            display: 'flex',
            alignItems: 'center',
            fontFamily: 'Barlow Condensed',
            fontWeight: 600,
            fontSize: '5.5vw',
          }}
        >
          {' '}
          <div style={{ marginRight: 15, width: 20 }}>
            <Icon icon={item.icon} size={20} color="white" />
          </div>{' '}
          <NavSubMenuText>{item.name}</NavSubMenuText>
        </div>
        <div
          style={{
            marginLeft: 25,
            width: 20,
            transform: active ? 'rotate(180deg)' : 'rotate(0deg)',
          }}
        >
          <Icon icon={'Down-Arrow'} size={17} color="white" />
        </div>{' '}
      </NavItemHeader>
      {active &&
        item.submenu.filter(Boolean).map((submenu, index) => (
          <NavSubItem
            exact
            to={submenu.link}
            key={index}
            onClick={() => hideMenu()}
          >
            {submenu.title}
          </NavSubItem>
        ))}
    </>
  );
};

export default SubMenu;
